import { Box } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseLongSection: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => (
	<Box
		data-testid="mui-card-desktop__right-section"
		sx={{
			paddingTop: spaces.md,
			display: 'flex',
			flexDirection: 'column',
			gap: spaces.lg,
			flex: '1 0 0',
			alignSelf: 'stretch',
		}}
	>
		{children}
	</Box>
);

export default MuiCardBaseLongSection;
